module.exports = __webpack_public_path__ + "static/media/shareLockGuide3.90ae24b9.png";